module.exports = __webpack_public_path__ + "img/LATIN10_14.2aebb096.jpg";